import GroupedShareBookmark from '../../../../components/grouped-share-bookmark/grouped-share-bookmark';
import groupedShareBookmark from './grouped-share-bookmark';

export default groupedShareBookmark(GroupedShareBookmark);
